import { useEffect, useRef, useState } from 'react';

// Detect guest -> authenticated transitions and expose flags for animations.
export default function usePromotionAnimations(presenceMap) {
  const prevRef = useRef(new Map());
  const [promotionSet, setPromotionSet] = useState(new Set());
  const [corePulse, setCorePulse] = useState(false);

  useEffect(() => {
    const ids = Object.keys(presenceMap || {});
    const nextPrev = new Map(prevRef.current);

    ids.forEach((id) => {
      const entry = presenceMap[id] || {};
      const status = String(entry.status || (entry.guest ? 'guest' : 'offline')).toLowerCase();
      const isGuest = !!entry.guest || status === 'guest';
      const prev = nextPrev.get(id);
      if (prev && prev.isGuest && !isGuest) {
        setPromotionSet((prevSet) => {
          const ns = new Set(prevSet);
          ns.add(id);
          return ns;
        });
        setCorePulse(true);
        setTimeout(() => setCorePulse(false), 220);
        setTimeout(() => {
          setPromotionSet((prevSet) => {
            const ns = new Set(prevSet);
            ns.delete(id);
            return ns;
          });
        }, 700);
      }
      nextPrev.set(id, { status, isGuest });
    });

    // prune removed ids
    nextPrev.forEach((_, id) => {
      if (!presenceMap[id]) nextPrev.delete(id);
    });

    prevRef.current = nextPrev;
  }, [presenceMap]);

  return { promotionSet, corePulse };
}
